<template>
  <div class="advisory pb-50">
    <van-sticky>
      <van-nav-bar :border="false">
        <template slot="left">
          <img :src="homeData.topLogo" alt="" class="logo-site">
        </template>
        <template slot="right">
          <div class="flex align-center">
            <router-link class="relative" to="/message">
              <van-icon name="envelop-o" class="msg" />
              <span v-show="messageCount > 0" class="dot">{{ messageCount }}</span>
            </router-link>
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>
    <mr-notice-bar></mr-notice-bar>
    <mr-banner :list="homeData.newsFocus"></mr-banner>

    <!-- tab栏目 -->
    <van-sticky :offset-top="46">
      <div class="tabs-wrapper">
        <div class="mr-tab">
          <div v-for="(item, index) in tabs" :key="index" class="tab" :class="{ 'active': activeName === item.id}" @click="toggleTab(item.id)">{{ item.name }}</div>
        </div>
      </div>
    </van-sticky>
    <!-- tab栏目 -->

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
      >
        <mr-advisory v-for="item in advisoryList" :key="item.id" :data="item"></mr-advisory>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import MrBanner from '@/pages/home/components/mr-swipe'
import MrNoticeBar from '@/pages/home/components/mr-notice-bar'
import MrAdvisory from '@/pages/home/components/mr-advisory'
import { mapState, mapMutations } from 'vuex'
import { getNoticeList } from '@/api/music.js'
import { getHomeData } from '@/api/common.js'
let keepAlive = false
export default {
  name: 'Advisory',
  beforeRouteEnter (to, from, next) {
    keepAlive = from.meta.keepAlive ? true : false
    next()
  },
  components: { MrBanner, MrNoticeBar, MrAdvisory },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      advisoryList: [],
      currentPage: 1,
      homeData: {},
      activeName: 'image'
    }
  },
  computed: {
    tabs() {
      return [
        { name: '图文资讯', id: 'image' },
        { name: '视频资讯', id: 'video' }
      ]
    },
    ...mapState(['isPlus', 'messageCount', 'currentRole'])
  },
  async created() {
    await this.getHomeData()
  },
  async activated() {
    if (!keepAlive) {
      try {
        this.TOGGLE_LOADING(true)
        await this.getNoticeList('refresh')
      } finally {
        this.TOGGLE_LOADING(false)
      }
    }
  },
  methods: {
    async toggleTab(id) {
      this.activeName = id
      this.currentPage = 1
      try {
        this.TOGGLE_LOADING(true)
        this.finished = false
        await this.getNoticeList('refresh')
      } finally {
        this.TOGGLE_LOADING(false)
      }
    },
    async getHomeData() {
      const res = await getHomeData({})
      this.homeData = res.data
    },
    async onRefresh() {
      this.currentPage = 1
      const len = await this.getNoticeList('refresh')
      if (len) {
        this.finished = false
      }
    },
    async onLoad() {
      this.loading = true
      this.currentPage = this.currentPage + 1
      const len = await this.getNoticeList()
      if (!len) {
        this.finished = true
      }
      this.loading = false
    },
    async getNoticeList(type) {
      if (this.currentPage === 0) return
      const res = await getNoticeList({ page: this.currentPage, type: this.currentRole === 0 ? 'cp' : 'agent', nature: this.activeName })
      const { current_page, data } = res.data
      this.currentPage = current_page
      this.refreshing = false
      if (type === 'refresh') {
        this.advisoryList = data
        return data.length
      }
      this.advisoryList = [...this.advisoryList, ...data]
      return data.length
    },
    ...mapMutations(['TOGGLE_LOADING'])
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/home.scss";
.advisory{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: calc(100vh - 46Px - 208px);
  }
}
</style>
